import Skeleton from "@/components/skeleton/Skeleton";

import styles from "./CasinoSkeleton.module.scss";

export type CasinoSkeletonVariant = "banner" | "title" | "subtitle" | "button" | "default";

type Props = {
  variant: CasinoSkeletonVariant;
  className?: string;
};

const CasinoSkeleton = ({ variant, className = "" }: Props) => {
  return <Skeleton className={`${styles.skeleton} ${styles[variant]} ${className}`} />;
};

export default CasinoSkeleton;
